import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=090efeb6&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "./feedback.vue?vue&type=style&index=0&id=090efeb6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090efeb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('090efeb6')) {
      api.createRecord('090efeb6', component.options)
    } else {
      api.reload('090efeb6', component.options)
    }
    module.hot.accept("./feedback.vue?vue&type=template&id=090efeb6&scoped=true", function () {
      api.rerender('090efeb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feedback/feedback.vue"
export default component.exports